import { Component, Input, OnInit } from '@angular/core';
import { ResponseErrorModel } from 'src/app/shared-services/models/response-error.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'response-error',
    templateUrl: './response-error.component.html',
    styleUrls: ['./response-error.component.scss']
})
export class ResponseErrorComponent implements OnInit {

    constructor() {
    }

    @Input() model: ResponseErrorModel;

    ngOnInit() {
    }
}
